<div class="totalContainer">
  <!--bg right-->
  <div class="bg-right">
    <img
      src="{{ onPassiveBaseUrl }}onpassive(nov2)/images/bg1.png"
      alt="bg1"
      width="100%"
    />
  </div>
  <!--bg right ends-->
  <!--bg left-->
  <div class="bg-left">
    <img
      src="{{ onPassiveBaseUrl }}onpassive(nov2)/images/bg2.png"
      alt="bg2"
      width="100%"
    />
  </div>
  <!--bg left ends-->
  <!--left right divs-->
  <div class="total-div">
    <div class="row">
      <div class="col-lg-7">
        <!--hand-globe div starts-->
        <div class="hand-globe">
          <div class="ray">
            <img src="{{ onPassiveBaseUrl }}onpassive(nov2)/images/ray.png" 
                 alt="ray"/>
          </div>
          <div class="sunrise-back">
            <!--  globe start -->
            <div class="globe">
              <div class="globe-img">
                <img
                  src="{{ onPassiveBaseUrl }}onpassive(nov2)/images/globe.png"
                  alt="globe"
                  width="100%"
                />
              </div>
              <div class="logo">
                <img
                  src="{{ onPassiveBaseUrl }}onpassive(nov2)/images/logo.png"
                  alt="logo"
                />
              </div>
            </div>
            <!-- globe ends-->
            <!--  hand start -->
            <div class="hand">
              <img
                src="{{ onPassiveBaseUrl }}onpassive(nov2)/images/hand.png"
                alt="hand"
              />
            </div>
            <!-- hand ends-->
          </div>
          <!-- sunrise back ends -->
        </div>
        <!--hand-globe div ends-->
      </div>
      <!--lg-7  ends-->
      <div class="col-lg-5 right">
        <!-- text effect -->
        <div class="sp-container">
          <div class="sp-content">
            <div class="sp-globe"></div>
            <h2 class="frame-1">
              NEW REVOLUTIONIZED INTERNET MARKETING SOLUTIONS
            </h2>
            <!-- <h2 class="frame-1">A UNICORN Company</h2>-->
          </div>
        </div>
        <!--text effect ends-->
        <h1 class="ml2">Launching Soon</h1>
        <!-- <h1 class="ml2">Commencing soon</h1>-->
        <p>
          Being at the right place at the right time is very important. Grab a
          rare opportunity which promises you success and a dignified lifestyle.
          Join a community of leading business people who believe in teamwork to
          enhance your growth. ONPASSIVE is the only platform which you have
          been searching all your life and the key is in your hands.
        </p>
        <div class="link-div">
          <a
            href="/registration/user?reg={{ userId }}"
            name="regform"
            class="btn-liquid"
            target="_blank"
            rel="noopener"
          >
            <span class="inner">become a founder</span>
          </a>
        </div>
      </div>
      <!--col-lg-5 ends-->
    </div>
    <!--row end-->
  </div>
  <!--total div ends-->
  <!--left right divs end-->
  <!--video start-->
  <div class="container-fluid video launching_video">
    <div class="video_box">
      <video
        id="my-video"
        class="video-js video-size w-100 h-auto"
        controls
        preload="auto"
        poster="{{ myLinksS3URL }}images/Image0231.png"
        data-setup="{}"
        autoplay="true"
        muted
        width="100%"
      >
        <source
          src="{{ myLinksS3URL }}videos/Onpassive_launching_page_video.mp4"
          type="video/mp4"
        />
      </video>
    </div>
  </div>
  <!--video end-->
</div>
